module.exports = __webpack_public_path__ + "img/lineup34@2x.e7607ed5.png";